import LinkWrapper from "../link-wrapper/link-wrapper";
import styles from "./link.module.less";
import { MouseEvent } from "react";

type TLinkProps = {
  className?: string;
  label?: string;
  iconRight?: string;
  iconLeft?: string;
};

type TLinkButtonProps = TLinkProps & {
  onClick?: () => void;
};

type TLinkAnchorProps = TLinkProps & {
  openInNewTab?: boolean;
  url: string;
  onPreNavigate?: (event: MouseEvent<HTMLAnchorElement>) => void;
};

type TContentProps = {
  label?: string;
  iconRight?: string;
  iconLeft?: string;
};

const PrimaryLinkButton = ({ className, ...rest }: TLinkButtonProps) => {
  return <Button className={[styles.primary, className ?? ""].join(" ")} {...rest} />;
};

const PrimaryLinkAnchor = ({ className, ...rest }: TLinkAnchorProps) => {
  return <ButtonLink className={[styles.primary, className ?? ""].join(" ")} {...rest} />;
};

const PrimaryLinkFake = ({ className, ...rest }: TLinkProps) => {
  return <ButtonFake className={[styles.primary, className ?? ""].join(" ")} {...rest} />;
};

const SecondaryLinkButton = ({ className, ...rest }: TLinkButtonProps) => {
  return <Button className={[styles.secondary, className ?? ""].join(" ")} {...rest} />;
};

const SecondaryLinkAnchor = ({ className, ...rest }: TLinkAnchorProps) => {
  return <ButtonLink className={[styles.secondary, className ?? ""].join(" ")} {...rest} />;
};

const SecondaryLinkFake = ({ className, ...rest }: TLinkProps) => {
  return <ButtonFake className={[styles.secondary, className ?? ""].join(" ")} {...rest} />;
};

const getCommonClasses = (): string => {
  return ["body-base mb-0", styles.common].join(" ");
};

const Content = ({ iconRight, iconLeft, label }: TContentProps) => {
  return (
    <div
      className={[
        styles.labelWrapper,
        iconRight ? styles.paddedIconRight : "",
        iconLeft ? styles.paddedIconLeft : "",
      ].join(" ")}
    >
      {iconLeft && <span className={`${styles.icon} ${styles.iconLeft} ${iconLeft}`} />}
      <div className={styles.label}>{label}</div>
      {iconRight && <span className={`${styles.icon} ${styles.iconRight} ${iconRight}`} />}
    </div>
  );
};

const ButtonLink = ({ className, label, iconLeft, iconRight, openInNewTab, url, onPreNavigate }: TLinkAnchorProps) => {
  const commonClasses = getCommonClasses();
  return (
    <LinkWrapper
      onPreNavigate={onPreNavigate}
      className={[styles.link, className ?? "", commonClasses].join(" ")}
      target={openInNewTab ? "_blank" : undefined}
      url={url}
      rel="noreferrer"
    >
      <Content iconLeft={iconLeft} iconRight={iconRight} label={label} />
    </LinkWrapper>
  );
};

const Button = ({ className, onClick, label, iconLeft, iconRight }: TLinkButtonProps) => {
  const commonClasses = getCommonClasses();

  return (
    <button type={"button"} className={[styles.button, className ?? "", commonClasses].join(" ")} onClick={onClick}>
      <Content iconLeft={iconLeft} iconRight={iconRight} label={label} />
    </button>
  );
};

const ButtonFake = ({ className, label, iconLeft, iconRight }: TLinkProps) => {
  const commonClasses = getCommonClasses();

  return (
    <div className={[styles.button, styles.fake, className ?? "", commonClasses].join(" ")}>
      <Content iconLeft={iconLeft} iconRight={iconRight} label={label} />
    </div>
  );
};

export const LinkAnchor = {
  Primary: PrimaryLinkAnchor,
  Secondary: SecondaryLinkAnchor,
};

export const LinkButton = {
  Primary: PrimaryLinkButton,
  Secondary: SecondaryLinkButton,
};

export const LinkFake = {
  Primary: PrimaryLinkFake,
  Secondary: SecondaryLinkFake,
};
